export default {
  className: '_User',
  render (record) {
    return record.phone
  },
  fields: [
    {
      name: 'phone',
      note: '手机号'
    },
    {
      name: 'isBlack',
      width: 200
    }
  ],
  search: [
    'phone',
    'isBlack'
  ],
  action: {
    export: false,
    create: false,
    edit: false,
    delete: false,
    setBlack: {
      type: 'row',
      text: '设为黑名单',
      hidden ({ record }) {
        return record && record.isBlack
      },
      callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
        await vm.confirm('警告', '您确定要将该用户设为黑名单吗?')
        try {
          await vm.$modelAjax.put(modelName, record.objectId, { isBlack: true })
          vm.$notification['success']({
            message: '操作成功',
            description: '设置成功'
          })
          vm.refresh()
        } catch (e) {
          console.log(e)
          vm.$notification['error']({
            message: '网络错误',
            description: '设置失败'
          })
        }
      }
    },
    cancel: {
      type: 'row',
      text: '移除黑名单',
      hidden ({ record }) {
        return record && !record.isBlack
      },
      callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
        await vm.confirm('警告', '您确定要将该用户从黑名单中移除吗?')
        try {
          await vm.$modelAjax.put(modelName, record.objectId, { isBlack: false })
          vm.$notification['success']({
            message: '操作成功',
            description: '移除成功'
          })
          vm.refresh()
        } catch (e) {
          console.log(e)
          vm.$notification['error']({
            message: '网络错误',
            description: '移除失败'
          })
        }
      }
    }
  }
}
